import React from "react";
import { Link } from "react-router-dom";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { ADMIN_PAGES, adminPagesBySection } from "./adminPages";

const AdminHub = () => {
  const sections = adminPagesBySection();

  return (
    <PageWrapper useNewFooter useLanding2Header>
      <main className="bg-white">
        <div className="mx-auto w-full max-w-[96rem] px-6 py-10 sm:px-8">
          <div className="mb-8">
            <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-gray-500">
              Admin
            </p>
            <h1 className="font-heading mt-2 text-3xl font-bold text-gray-900">Admin tools</h1>
            <p className="mt-2 max-w-2xl text-sm text-gray-600">
              Internal Occasia admin pages. You have access to {ADMIN_PAGES.length} tool
              {ADMIN_PAGES.length === 1 ? "" : "s"}.
            </p>
          </div>

          <div className="space-y-8">
            {sections.map(([section, pages]) => (
              <section key={section}>
                <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500">
                  {section}
                </h2>
                <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {pages.map((page) => (
                    <li key={page.path}>
                      <Link
                        to={page.path}
                        className="group flex h-full flex-col rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-all hover:border-[#046242]/40 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#046242]/40 focus:ring-offset-2"
                      >
                        <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#046242]">
                          {page.title}
                        </h3>
                        <p className="mt-2 flex-1 text-sm leading-relaxed text-gray-600">
                          {page.description}
                        </p>
                        <p className="mt-4 font-mono text-xs text-gray-400">{page.path}</p>
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </div>
      </main>
    </PageWrapper>
  );
};

export default AdminHub;
